export default __webpack_public_path__ + "static/media/no-connection.c52dcae8.svg";